const InvoiceStatus = [
  {
    id: 1,
    name: 'Invoice', //
    subFilter: [
      {
        id: 1,
        name: 'Generated',
        access: ['view_invoice', 'verify_invoice', 'accept_invoice', 'reject_invoice'],
      },
      {
        id: 2,
        name: 'Checked',
        access: ['verify_invoice', 'accept_invoice', 'reject_invoice'],
      },
      {
        id: 4,
        name: 'Returned',
        access: ['verify_invoice', 'accept_invoice', 'reject_invoice'],
      },
      {
        id: 13,
        name: 'Re Submitted',
        access: ['verify_invoice', 'accept_invoice', 'reject_invoice'],
      },
      {
        id: 8,
        name: 'On Hold',
        access: ['verify_invoice', 'accept_invoice', 'reject_invoice', 'librarian_accept_invoice', 'librarian_reject_invoice'],
      },
      {
        id: 3,
        name: 'Approved',
        access: ['verify_invoice', 'accept_invoice', 'librarian_accept_invoice', 'librarian_reject_invoice'],
      },
      {
        id: 7,
        name: 'Verified',
        access: ['librarian_accept_invoice', 'librarian_reject_invoice', 'accounts_accept_invoice', 'accounts_reject_invoice'],
      },
      {
        id: 9,
        name: 'Posted',
        access: ['librarian_accept_invoice', 'accounts_accept_invoice', 'accounts_reject_invoice'],
      },
      {
        id: 10,
        name: 'Payment Hold',
        access: ['librarian_accept_invoice', 'accounts_accept_invoice', 'accounts_reject_invoice'],
      },
    ],
  },
  {
    id: 3,
    name: 'Paid',
    subFilter: [
      {
        id: 11,
        name: 'Paid',
        access: ['accounts_accept_invoice', 'accounts_reject_invoice'],
      },
    ],
  },
];

const VoucherInvoiceStatus = [
  {
    id: 1,
    name: 'Invoice', //
    subFilter: [
      {
        id: 1,
        name: 'Generated',
        access: ['verify_invoice', 'accept_invoice', 'reject_invoice'],
      },
      {
        id: 14,
        name: 'Invoice Updates',
        access: ['verify_invoice', 'accept_invoice', 'reject_invoice'],
      },
    ],
  },
  {
    id: 2,
    name: 'Voucher',
    subFilter: [
      {
        id: 15,
        name: 'Pending',
        access: ['accept_invoice', 'librarian_accept_invoice', 'librarian_reject_invoice'],
      },
      {
        id: 3,
        name: 'Approved',
        access: ['accept_invoice', 'librarian_accept_invoice', 'librarian_reject_invoice'],
      },
      {
        id: 8,
        name: 'On Hold',
        access: ['librarian_accept_invoice', 'invoice_generate_voucher'],
      },
      {
        id: 7,
        name: 'Verified',
        access: ['librarian_accept_invoice', 'librarian_reject_invoice', 'accounts_accept_invoice', 'accounts_reject_invoice'],
      },
      {
        id: 9,
        name: 'Posted',
        access: ['librarian_accept_invoice', 'accounts_accept_invoice', 'accounts_reject_invoice'],
      },
      {
        id: 10,
        name: 'Payment Hold',
        access: ['librarian_accept_invoice', 'accounts_accept_invoice', 'accounts_reject_invoice'],
      },
      {
        id: 11,
        name: 'Paid',
        access: ['librarian_accept_invoice', 'accounts_accept_invoice', 'accounts_reject_invoice'],
      },
    ],
  },
];
module.exports = { InvoiceStatus, VoucherInvoiceStatus };
